<template>
  <div>Loading...</div>
</template>

<script>
import {
  GoogleAuthProvider,
  OAuthProvider,
  signInWithCredential,
} from "firebase/auth";
// import { getFunctions, httpsCallable } from 'firebase/functions';
import Config from "../../../config-app/config";
import { auth, authShared } from "../../../config-firebase/firebase";
import toast from "../../js/toast";
import mixins from "../../js/mixins";
import store from "../../store";

export default {
  name: "login-sdk-android",
  mixins: [mixins, toast],
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
    };
  },

  methods: {
    handleGoogleSignIn(id_token) {
      const credential = GoogleAuthProvider.credential(id_token);
      return this.handleSignInWithCredential(credential);
    },
    handleAppleSignIn(id_token) {
      const provider = new OAuthProvider("apple.com");
      const credential = provider.credential({ idToken: id_token });
      return this.handleSignInWithCredential(credential);
    },
    handleSignInWithCredential(credential) {
      return signInWithCredential(authShared, credential);
      // Ho provato a autenticare anche su auth.
      //  Ma funziona solo su Google e non su Apple.
      // Vedi le prove fatte per Apple in handleAppleIDSignInOnSuccess
      // Per ora standalone userà solo 1 DB :(
      // .then(() => {
      //   console.log('credential', credential)
      //   return signInWithCredential(auth, credential)
      // })
    },
    signInRouter(id_token, provider) {
      if (provider == "google") {
        return this.handleGoogleSignIn(id_token);
      } else if (provider == "apple") {
        return this.handleAppleSignIn(id_token);
      }
    },
    signIn(id_token, provider) {
      this.signInRouter(id_token, provider)
        .then((result) => {
          let user = result.user;
          this.successToast("Ciao", user.displayName);
          let redirect = this.$route.query.redirect || "/";
          this.$router.push({ path: redirect });
          Android.closeLoginPanel();
          Android.showPopup("Ciao" + user.displayName);
        })
        .catch((error) => {
          this.errorToast("Login Error", error.message);
          console.log("Login Error: ", error);
          Android.showPopup("Errore:" + error.message);
        });
    },
  },

  created() {
    console.log("Calling Android.showLoginPanel()");
    this.successToast("Calling Android.showLoginPanel()", "");

    // Javascript -> Android
    Android.showLoginPanel();

    // Android -> Javascript
    window.androidBridge = {
      signInFromAndroid: (idToken, provider) => this.signIn(idToken, provider),
    };
  },

  mounted() {
    console.log("LoginSdkAndroid ready.");
  },

  destroyed() {
    console.log("LoginSdkAndroid destroyed.");
  },
};
</script>

<style lang="scss" scoped>
</style>
